module.exports = __webpack_public_path__ + "static/tracy-754e70262ecefed9b03950c4fecad4b9.jpg";